import { render, staticRenderFns } from "./DealStreamItem.vue?vue&type=template&id=d0fd97e2"
import script from "./DealStreamItem.vue?vue&type=script&lang=js"
export * from "./DealStreamItem.vue?vue&type=script&lang=js"
import style0 from "./DealStreamItem.vue?vue&type=style&index=0&id=d0fd97e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports